

<nz-layout>

  <nz-content>
    <div class="box-wrapper">
      <div class="box-div">

        <div class="px-4">
          <img
            [src]="bas.ws.getBaseUrlPf() + '/pf/img/company/'+bas.ds.findCid('lib.user.confirm')+'/logo_1000x200.png'"
            style=""
            class="w-100 mb-d"
            />
        </div>

        <div></div>

        @if (data.error) {
          <div>
            <p [innerHTML]="data.error | actrans"></p>
            <button nz-button nzBlock nzType="primary" (click)="gotoHome()">{{ 'app.lib.common.gotoFrontpage' | actrans }}</button>
          </div>
        }

        @if (!data.error) {
          <div>
            <!-- <p>{{ ''  | actrans }}</p> -->
            @if (step == 0) {
              <div class="text-center">
                <p class="text-center  mt-8">{{ 'app.lib.pages.user.confirm.desc'  | actrans }}</p>
                <p class="">
                  <button nz-button nzType="primary" [nzLoading]="data.loading" (click)="confirm()">{{ 'app.lib.pages.user.confirm' | actrans }}</button>
                </p>
              </div>
            }
            @if (step == 1) {
              <div>
                <p class="text-center">{{ 'app.lib.pages.user.confirm.enterNewPassword' | actrans }}</p>
                <form nz-form [formGroup]="edit.form" (ngSubmit)="savePassword()"  class="item-form " nzLayout="vertical" [nzAutoTips]="bas.fs.autoTips" >
              <btlib-form-row [controls]="[ 
                edit.controls.passwordNew,
                edit.controls.passwordConfirm,

              ]" [form]="edit.form"  [grid]="bas.ui.gridFull"  [options]="edit.controlOptions || { nomargin: true }" ></btlib-form-row> 
                  @if (edit.error) {
                    <nz-alert
                      class="my-8"
                      nzType="error"
                      [nzMessage]="edit.error | actrans | str"
                      nzShowIcon>
                    </nz-alert>
                  }
                  <button  class="mt-d"  nz-button nzBlock nzType="primary" [nzLoading]="data.loading">{{ 'app.lib.common.save' | actrans }}</button>
                </form>
              </div>
            }
            @if (step == 2) {
              <div>
                <p class="text-center">{{ 'app.lib.pages.user.confirm.confirmed' | actrans }}</p>
                <button nz-button nzBlock nzType="primary" (click)="gotoHome()">{{ 'app.lib.common.ok' | actrans }}</button>
                <!-- <a href="" class="btn btn-lg btn-success btn-block btn-exit"><nit:message key="common.ok" ct="false" /></a> -->
              </div>
            }
         
          </div>
        }


      </div>
    </div>


  </nz-content>

</nz-layout>
